import React, { useEffect } from "react";
import { Provider } from "react-redux";

import RootRoutes from "./routes";
import store from "./store/configureStore";

// import "bootstrap/dist/css/bootstrap.min.css";
import "./css/egov-base.css";
import "./css/egov-layout.css";
import "./css/egov-component.css";
import "./css/egov-page.css";
// import "./css/egov-response.css";
import "./css/custom-style.scss";
import "./css/sff-style.scss";
import "./css/radio-checkbox.scss";
import { PageProvider } from "./components/PageProvider";
import Modal from "react-modal";
import { BrowserRouter } from "react-router-dom";

function App() {
	return (
		<PageProvider>
			<div className="wrap">
				<Provider store={store}>
					<BrowserRouter>
						<RootRoutes />
					</BrowserRouter>
				</Provider>
			</div>
		</PageProvider>
	);
}

Modal.setAppElement('#root')

export default App;
